(() => {
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : "/";
  const cfg = window.LTGLNCartCustom || {};
  const protectionVariants = [
    { id: 1, price: 0, minPrice: 0, maxPrice: 0 },
    { id: 40583184646218, price: 1.15, minPrice: 0.01, maxPrice: 25 },
    { id: 40583184678986, price: 1.25, minPrice: 25.01, maxPrice: 50 },
    { id: 40583184711754, price: 1.32, minPrice: 50.01, maxPrice: 75 },
    { id: 40583184744522, price: 1.52, minPrice: 75.01, maxPrice: 100 },
    { id: 40583184777290, price: 2.24, minPrice: 100.01, maxPrice: 150 },
    { id: 40583184810058, price: 2.98, minPrice: 150.01, maxPrice: 200 },
    { id: 40583184842826, price: 3.73, minPrice: 200.01, maxPrice: 250 },
    { id: 40583184875594, price: 4.48, minPrice: 250.01, maxPrice: 300 },
    { id: 40583184908362, price: 5.24, minPrice: 300.01, maxPrice: 350 },
    { id: 40583184941130, price: 5.97, minPrice: 350.01, maxPrice: 400 },
    { id: 40583184973898, price: 6.81, minPrice: 400.01, maxPrice: 450 },
    { id: 40583185006666, price: 7.6, minPrice: 450.01, maxPrice: 500 },
    { id: 40583188545610, price: 8.4, minPrice: 500.01, maxPrice: 550 },
    { id: 40583188578378, price: 9.2, minPrice: 550.01, maxPrice: 600 },
    { id: 99999999999999, price: 0, minPrice: 600.01, maxPrice: Infinity }
  ];
  const cashAmounts = {
    40114119082058: 5,
    40114119114826: 10,
    40114119147594: 15
  };
  const donationVariantId = 41960222392394;
  const protectionIds = new Set(protectionVariants.map((variant) => variant.id));
  const cashIds = new Set(Object.keys(cashAmounts).map(Number));
  let syncingPromos = false;
  let checkoutRunning = false;

  const money = (value) => `$${Number(value || 0).toFixed(2)} USD`;
  const isProtectionItem = (item) => protectionIds.has(Number(item.variant_id));
  const isCashItem = (item) => cashIds.has(Number(item.variant_id));

  async function fetchCart() {
    const response = await fetch(`${root}cart.js`, { credentials: "same-origin" });
    if (!response.ok) throw new Error("Unable to fetch cart");
    return response.json();
  }

  async function refreshCartSections() {
    const sections = await fetch(`${root}?sections=cart-drawer,cart,cart-bubble`).then((response) => response.json());
    document.dispatchEvent(new CustomEvent("cart-update", { detail: { sections }, bubbles: true }));
  }

  async function updateCart(updates) {
    return fetch(`${root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      credentials: "same-origin",
      body: JSON.stringify({ updates })
    }).then((response) => response.json());
  }

  async function addVariant(variantId) {
    return fetch(`${root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      credentials: "same-origin",
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then((response) => response.json());
  }

  function selectedProtectionVariant(cart) {
    const subtotal = cart.items
      .filter((item) => item.requires_shipping && !isProtectionItem(item))
      .reduce((sum, item) => sum + Number(item.final_line_price || item.price * item.quantity || 0), 0) / 100;

    return protectionVariants.find((variant) => subtotal >= variant.minPrice && subtotal <= variant.maxPrice);
  }

  function updateProtectionUi(cart) {
    const checkbox = document.querySelector("#shipping-protection-checkbox");
    const price = document.querySelector(".shipping-protection-price");
    const total = document.querySelector(".shipping-protection-total-price span");
    if (!checkbox && !price && !total) return;

    const selected = selectedProtectionVariant(cart);
    const protectionTotal = cart.items.filter(isProtectionItem).reduce((sum, item) => sum + Number(item.final_line_price || 0), 0) / 100;
    const baseTotal = (cart.total_price / 100) - protectionTotal;
    const hasShippableItems = cart.items.some((item) => item.requires_shipping && !isProtectionItem(item));
    const canProtect = selected && selected.id !== 1 && selected.id !== 99999999999999 && hasShippableItems;

    if (price) price.textContent = canProtect ? money(selected.price) : "";
    if (checkbox) {
      checkbox.disabled = !canProtect;
      if (!canProtect) checkbox.checked = false;
    }
    if (total) total.textContent = money(baseTotal + (checkbox && checkbox.checked && canProtect ? selected.price : 0));

    const donationCheckbox = document.querySelector("#custom_product_checkbox");
    if (donationCheckbox) {
      donationCheckbox.checked = cart.items.some((item) => Number(item.variant_id) === donationVariantId);
    }
  }

  async function removeProtection(cart) {
    const updates = {};
    cart.items.filter(isProtectionItem).forEach((item) => {
      updates[item.variant_id] = 0;
    });
    if (Object.keys(updates).length) await updateCart(updates);
  }

  async function applyProtection(cart) {
    const checkbox = document.querySelector("#shipping-protection-checkbox");
    const selected = selectedProtectionVariant(cart);
    if (!checkbox || !checkbox.checked || !selected || selected.id === 1 || selected.id === 99999999999999) {
      await removeProtection(cart);
      return;
    }

    const matching = cart.items.filter(isProtectionItem);
    const hasSelected = matching.some((item) => Number(item.variant_id) === selected.id);
    if (matching.length > 1 || !hasSelected) {
      await removeProtection(cart);
      await addVariant(selected.id);
    }
  }

  async function applyDonation(cart) {
    const checkbox = document.querySelector("#custom_product_checkbox");
    if (!checkbox) return;

    const variantId = Number(checkbox.dataset.variantId || donationVariantId);
    const exists = cart.items.some((item) => Number(item.variant_id) === variantId);
    if (checkbox.checked && !exists) {
      await addVariant(variantId);
    } else if (!checkbox.checked && exists) {
      await updateCart({ [variantId]: 0 });
    }
  }

  async function syncFreeGift(cart) {
    if (!cfg.freeGiftEnabled || !cfg.giftProductHandle || !cfg.giftThreshold) return false;
    const product = await fetch(`${root}products/${cfg.giftProductHandle}.js`).then((response) => response.ok ? response.json() : null);
    const variantId = product && product.variants && product.variants[0] && Number(product.variants[0].id);
    if (!variantId) return false;

    const qualifies = cart.total_price / 100 >= Number(cfg.giftThreshold);
    const exists = cart.items.some((item) => Number(item.variant_id) === variantId);
    if (qualifies && !exists) {
      await addVariant(variantId);
      return true;
    }
    if (!qualifies && exists) {
      await updateCart({ [variantId]: 0 });
      return true;
    }
    return false;
  }

  async function syncGoodLifeCash(cart) {
    if (!cfg.goodLifeCashEnabled) return false;
    const cartTotal = cart.items
      .filter((item) => !isCashItem(item))
      .reduce((sum, item) => sum + Number(item.final_line_price || 0), 0) / 100;
    let freeProduct = null;
    if (cartTotal >= 75 && cartTotal < 125) freeProduct = 40114119082058;
    if (cartTotal >= 125 && cartTotal < 175) freeProduct = 40114119114826;
    if (cartTotal >= 175) freeProduct = 40114119147594;

    const updates = {};
    cart.items.filter(isCashItem).forEach((item) => {
      if (!freeProduct || Number(item.variant_id) !== freeProduct) updates[item.variant_id] = 0;
    });
    if (Object.keys(updates).length) {
      await updateCart(updates);
      cart = await fetchCart();
    }
    if (freeProduct && !cart.items.some((item) => Number(item.variant_id) === freeProduct)) {
      await addVariant(freeProduct);
      return true;
    }
    return Object.keys(updates).length > 0;
  }

  async function syncPromos() {
    if (syncingPromos) return;
    syncingPromos = true;
    try {
      let cart = await fetchCart();
      updateProtectionUi(cart);
      const changedGift = await syncFreeGift(cart);
      if (changedGift) cart = await fetchCart();
      const changedCash = await syncGoodLifeCash(cart);
      if (changedGift || changedCash) await refreshCartSections();
    } catch (error) {
      console.error("LTGLN cart sync failed", error);
    } finally {
      syncingPromos = false;
    }
  }

  async function handleCheckout(event) {
    const checkoutLink = event.target.closest(".ltgln-checkout-link, .shipping-protection-checkout");
    if (!checkoutLink || checkoutRunning) return;
    event.preventDefault();
    checkoutRunning = true;
    checkoutLink.setAttribute("aria-busy", "true");
    try {
      let cart = await fetchCart();
      await applyProtection(cart);
      cart = await fetchCart();
      await applyDonation(cart);
      window.location.href = `${root}checkout`;
    } catch (error) {
      console.error("LTGLN checkout prep failed", error);
      window.location.href = `${root}checkout`;
    }
  }

  async function setCartIpAttribute() {
    if (!cfg.ipInfoToken) return;
    const cacheKey = "dek_ip_cache_v1";
    const ttl = 30 * 60 * 1000;
    let ip = null;
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey) || "null");
      if (cached && cached.ip && Date.now() - cached.ts < ttl) ip = cached.ip;
    } catch {}
    if (!ip) {
      try {
        const response = await fetch(`https://ipinfo.io?token=${cfg.ipInfoToken}`, { credentials: "omit" });
        const data = response.ok ? await response.json() : null;
        ip = data && data.ip;
      } catch {}
    }
    if (!ip) {
      try {
        const response = await fetch("https://api.ipify.org?format=json", { credentials: "omit" });
        const data = response.ok ? await response.json() : null;
        ip = data && data.ip;
      } catch {}
    }
    if (!ip) return;
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify({ ip, ts: Date.now() }));
      const cart = await fetchCart();
      if (cart.attributes && cart.attributes.ip_address === ip) return;
      await fetch(`${root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ attributes: { ...(cart.attributes || {}), ip_address: String(ip) } })
      });
    } catch {}
  }

  document.addEventListener("DOMContentLoaded", () => {
    syncPromos();
    setCartIpAttribute();
  });
  document.addEventListener("cart-update", () => window.setTimeout(syncPromos, 100));
  document.addEventListener("change", (event) => {
    if (event.target.matches("#shipping-protection-checkbox, #custom_product_checkbox")) {
      fetchCart().then(updateProtectionUi).catch(() => {});
    }
  });
  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-shipping-protection-open]")) {
      event.preventDefault();
      document.querySelector(".shipping-protection-popup")?.removeAttribute("hidden");
    }
    if (event.target.closest("[data-shipping-protection-close]")) {
      event.preventDefault();
      document.querySelector(".shipping-protection-popup")?.setAttribute("hidden", "");
    }
    if (event.target.closest("#checkButton")) {
      event.preventDefault();
      const checkbox = document.querySelector("#custom_product_checkbox");
      if (checkbox) {
        checkbox.checked = true;
        fetchCart().then(updateProtectionUi).catch(() => {});
      }
    }
    handleCheckout(event);
  });
})();
